const variantElements = document.querySelectorAll('.variantItem');
const variantNameSpan = document.querySelector('.variant-name');
const galleryImages = document.querySelectorAll('.gallery-image');
let originalVariantName = variantNameSpan.textContent;
let originalGalleryImageSrcsets = [];
let codeEnabled = true;
galleryImages.forEach((image) => {
  originalGalleryImageSrcsets.push(image.srcset);
});
variantElements.forEach((variantElement, index) => {
  variantElement.addEventListener('mouseover', () => {
    if (codeEnabled) {
      variantNameSpan.textContent = variantElement.getAttribute('data-name');

      const variantImage = variantElement.querySelector('.variant-image');
      const variantImageSrc = variantImage.getAttribute('data-fullsize-src');

      galleryImages.forEach((image, i) => {
        image.srcset = variantImageSrc;
      });
    }
  });
  variantElement.addEventListener('mouseout', () => {
    if (codeEnabled) {
      variantNameSpan.textContent = originalVariantName;

      galleryImages.forEach((image, i) => {
        image.srcset = originalGalleryImageSrcsets[i];
      });
    }
  });
});

const ratingBadge = document.querySelector('.rating-badge');
ratingBadge.addEventListener('click', () => {
  codeEnabled = false;
  setTimeout(() => {
    codeEnabled = true;
  }, 4000);
});

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.querySelector('.variantItem.current');
  const container = document.querySelector('.variant-picker__options');

  if (targetElement && container) {
    const scrollOffset = 0;
    const scrollPosition = targetElement.offsetLeft - container.offsetLeft - scrollOffset;
    container.scrollLeft = scrollPosition;
  }
});